// @flow

import { connect } from 'react-redux';
import { getUiSetting, setUiSetting, toggleUiBooleanSetting } from '../../store/uiStore';

import type { DispatchProps, StateProps } from './types';

export default (drawerName: string) => {
  const mapStateToProps = (state): StateProps => ({
    open: getUiSetting(state, drawerName),
  });

  const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    handleClose: () => dispatch(setUiSetting(drawerName, false)),
    toggle: () => dispatch(toggleUiBooleanSetting(drawerName)),
  });

  return connect<any, any, StateProps, DispatchProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
  );
};
